const config = {
    basedomain: process.env.VUE_APP_API_URL,
};

export default config;
